import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

const API_BASE_URL = `${window.location.protocol}//${window.location.hostname}/api`;
function api(path, opts = {}) {
  const token = localStorage.getItem('token');
  return fetch(`${API_BASE_URL}${path}`, {
    ...opts,
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}`, ...opts.headers },
  }).then(async r => {
    const d = await r.json().catch(() => ({}));
    if (!r.ok) throw new Error(d.message || d.error || `HTTP ${r.status}`);
    return d;
  });
}

const wrap = { minHeight: '100vh', backgroundColor: '#0f172a', color: '#e2e8f0', fontFamily: 'sans-serif', padding: 20 };

export default function MaterialCheckout() {
  const { uuid } = useParams();
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  useEffect(() => {
    api(`/materials/order/${uuid}`)
      .then(d => { setOrder(d); setLoading(false); })
      .catch(e => { setError(e.message); setLoading(false); });
  }, [uuid]);

  const checkout = async () => {
    setBusy(true);
    try { await api(`/materials/order/${uuid}/checkout`, { method: 'POST' }); setDone(true); }
    catch (e) { setError(e.message); }
    finally { setBusy(false); }
  };

  if (loading) return <div style={wrap}>Loading…</div>;
  if (error) return <div style={{ ...wrap, color: '#fca5a5' }}>Could not load order: {error}<div style={{ color: '#64748b', fontSize: 13, marginTop: 8 }}>Make sure you are logged in to FieldCore on this device.</div></div>;
  if (!order) return <div style={{ ...wrap, color: '#fca5a5' }}>Order not found.</div>;

  return (
    <div style={wrap}>
      <div style={{ maxWidth: 480, margin: '0 auto' }}>
        <div style={{ fontSize: 13, color: '#64748b', letterSpacing: 1, marginBottom: 6 }}>📦 MATERIAL PICKUP</div>
        <div style={{ fontSize: 22, fontWeight: 800, marginBottom: 4 }}>{order.work_item_title}</div>
        <div style={{ color: '#94a3b8', marginBottom: 16, fontSize: 13 }}>
          {order.wo_number ? `WO ${order.wo_number}` : ''}{order.po_number ? ` · PO ${order.po_number}` : ''}{order.location_name ? ` · ${order.location_name}` : ''}
        </div>

        <div style={{ backgroundColor: '#1e293b', border: '1px solid #334155', borderRadius: 10, padding: 16, marginBottom: 16 }}>
          {(order.items || []).map(i => (
            <div key={i.id} style={{ display: 'flex', justifyContent: 'space-between', padding: '6px 0', borderBottom: '1px solid #0f172a', fontSize: 14 }}>
              <span>{i.description}</span>
              <span style={{ fontWeight: 700 }}>{i.received_qty != null ? i.received_qty : i.expected_qty} {i.unit || ''}</span>
            </div>
          ))}
        </div>

        {done ? (
          <div style={{ textAlign: 'center', padding: 24, backgroundColor: '#0d2818', border: '1px solid #16632a', borderRadius: 10 }}>
            <div style={{ fontSize: 40 }}>✅</div>
            <div style={{ fontWeight: 800, fontSize: 18, color: '#4ade80', marginTop: 6 }}>Checked out</div>
            <div style={{ color: '#94a3b8', fontSize: 13, marginTop: 4 }}>This order is now assigned to you for the job.</div>
          </div>
        ) : order.existing_checkout ? (
          <div style={{ textAlign: 'center', padding: 20, backgroundColor: '#3a2e0a', border: '1px solid #854d0e', borderRadius: 10, color: '#fbbf24', fontWeight: 700 }}>
            This order is already checked out.
          </div>
        ) : (
          <button onClick={checkout} disabled={busy} style={{ width: '100%', padding: 16, backgroundColor: '#166534', color: '#dcfce7', border: 'none', borderRadius: 8, fontWeight: 800, fontSize: 16, cursor: 'pointer' }}>
            {busy ? 'Checking out…' : 'Confirm Pickup — Check Out Order'}
          </button>
        )}
      </div>
    </div>
  );
}
